module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/tutorial2_ee98d5.jpg";